import React from "react";
import {V5Image, V5ImageProps} from "src/useV5ImgSrc";

type Props = Omit<V5ImageProps, "alt"> & {
  type:
    | "circle"
    | "circle2"
    | "underline"
    | "single-underline"
    | "yellow-underline"
    | "blue-underline"
    | "double-yellow-underline";
};

export const IllustratedTextDecoration: React.FC<Props> = ({
  type,
  style,
  className,
  width = "100%",
  ...props
}) => (
  <V5Image
    style={{bottom: type === "circle" ? 1 : -14, ...style}}
    src={`home/word-${type}`}
    className={`pos-a-center right0 left0 ma maxw-none zIndex-1 ${className}`}
    width={width}
    {...props}
    alt=""
  />
);
